<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    title="批量选择"
    class="small-dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="150px">
      <el-form-item label="题目类型">
        <el-select v-model="type" disabled>
          <el-option
            v-for="item in topicType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属章节">
        <el-select
          ref="chapterSelectRef"
          v-model="form.chapterId"
          placeholder="请选择所属章节"
          popper-class="chapter-select-tree"
          size="small"
          @visible-change="chapterSelectChange"
          clearable
          @clear="clearSelect"
        >
          <el-option
            :label="chapterName"
            :value="form.chapterId"
            :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
          >
            <el-tree
              :props="{
                label: 'questionBankName',
                children: 'childs',
              }"
              class="text-white max-h-274px overflow-x-hidden chapter-tree"
              ref="chapterTreeRef"
              node-key="id"
              highlight-current
              :data="chapterData"
              @node-click="treeNodeClick"
              :expand-on-click-node="false"
              :default-expanded-keys="defaultExpandedKeys"
            >
              <div slot-scope="{ data }" class="text-color-primary">
                {{ data.questionBankName || data.chapterName }}
              </div>
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目数量" prop="num">
        <el-input-number
          v-model="form.num"
          :min="1"
          :controls="false"
          class="w-440px"
          @change="updateScore"
        />
      </el-form-item>
      <el-form-item label="赋值方式" prop="type">
        <el-select v-model="form.type" @change="updateScore">
          <el-option label="单个赋分" :value="0"></el-option>
          <el-option label="总体赋分" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="form.type === 0 ? '单个分值' : '总体分值'" prop="score">
        <el-input-number
          v-model="form.score"
          :min="form.type === 0 ? 1 : form.num"
          :step="form.type === 0 ? 1 : form.num"
          :controls="false"
          :step-strictly="true"
          class="w-440px"
          :key="updateKey"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        :loading="loading"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { random, map } from 'lodash'
import { QuestionSourceApi, QuestionBankApi } from '@wiz-api/exam-management'

const questionSourceApi = new QuestionSourceApi()
const questionBankApi = new QuestionBankApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 0,
    },
    excludeIds: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      topicType: [
        { label: '单选题', value: 0 },
        { label: '多选题', value: 1 },
        { label: '判断题', value: 2 },
        { label: '填空题', value: 3 },
        { label: '简答题', value: 4 },
      ],
      form: {
        type: 0,
        score: 1,
        num: 1,
        chapterId: '',
      },
      chapterName: '',
      currentNode: {},
      chapterData: [],
      defaultExpandedKeys: [],
      rules: {
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        type: [{ required: true, message: '请选择赋值方式', trigger: 'change' }],
      },
      updateKey: random(0, 1000),
      loading: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getChapterData()
      }
    },
  },
  methods: {
    clearSelect() {
      this.chapterName = ''
      this.currentNode = {}
    },
    async getChapterData() {
      const [err, res] = await questionBankApi.getTreeList()
      if (!err) {
        this.chapterData = res
      }
    },
    chapterSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.chapterTreeRef.setCurrentKey(this.form.chapterId) // 设置选中元素
          this.defaultExpandedKeys = [this.form.chapterId]
        } else {
          const nodeDatas = this.$refs.chapterTreeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      this.form.chapterId = node.chapterId || node.id
      this.chapterName = node.chapterName || node.questionBankName
      this.currentNode = node
      this.$refs.chapterSelectRef.blur()
    },
    updateScore() {
      this.updateKey = random(0, 1000)
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const [err, res] = await questionSourceApi.randomQuery({
            body: {
              examType: this.type,
              questionCount: this.form.num,
              excludeIds: this.excludeIds,
              chapterId: this.currentNode.chapterId ? this.currentNode.chapterId : null,
              bankId: this.currentNode.chapterId ? null : this.currentNode.id,
            },
          })
          this.loading = false
          if (!err) {
            if (res.totalCount < this.form.num) {
              this.$message.warning('题目数量已超过题库当前题型剩余的数量！')
              return
            }
            const score = this.form.type === 0 ? this.form.score : this.form.score / this.form.num
            const data = map(res.items, (item) => {
              return {
                ...item,
                score,
              }
            })
            this.$emit('save', data)
            this.closeDialog()
          }
        }
      })
    },
    closeDialog(done) {
      this.form = this.$options.data().form
      this.chapterName = ''
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chapter-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.chapter-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
